module.exports = __webpack_public_path__ + "static/media/logo.c372cf12.png";